import { LeaveType } from '../LeaveType.enum'

function getLabel(val: LeaveType, otherType?: string) {
  switch (val) {
    case LeaveType.ANNUAL_LEAVE:
      return 'Annual Leave'
    case LeaveType.SICK_LEAVE:
      return 'Sick Leave'
    case LeaveType.COMPASSIONATE_LEAVE:
      return 'Compassionate Leave'
    case LeaveType.MARRIAGE_LEAVE:
      return 'Marriage Leave'
    case LeaveType.PATERNITY_OR_MATERNITY:
      return 'Paternity/Maternity Leave'
    case LeaveType.HOSPITALIZATION_LEAVE:
      return 'Hospitalization Leave'
    case LeaveType.OTHER:
      if (otherType) return `Other Leave - ${otherType}`
      return 'Other Leave'
    default:
      return ''
  }
}

const LeaveTypeEnumHelper = {
  getLabel,
}

export default LeaveTypeEnumHelper
